import React from 'react';
import HeroSection4 from '../components/herosections/HeroSection4';
import TrustedBrands from '../components/home/TrustedBrands';
import AboutUs from '../components/home/AboutUs';
import Services from '../components/home/Services';
import Team from '../components/home/Team';
import FAQs from '../components/home/FAQs';
import Blog from '../components/home/Blog';

const Home4 = () => {
    return (
        <>
            <HeroSection4 />
            <TrustedBrands />
            <AboutUs />
            <Services />
            <Team />
            <Blog />
            <FAQs />
        </>
    )
}

export default Home4;
